import { strings } from '@/shared/strings';
import { WidgetBoard } from './WidgetBoard';

/**
 * The Dashboard: a person's own page of widgets, and where whoever holds it
 * lands. The lab's request of 12 October 2026.
 *
 * Reception's and Accounts' to begin with, and anybody's the lab gives it to
 * in the access matrix. What is on it follows what the person holds: the cases
 * and the dispatch desk for somebody with Orders, Shipping and On Hold, the
 * money for somebody with Payments, and for everybody their notifications and
 * their screens. Customize adds, takes off and reorders.
 */
export function DashboardScreen() {
  return (
    <WidgetBoard screen="dashboard" label={strings.dashboard.label} title={strings.dashboard.title} />
  );
}
